import { render, staticRenderFns } from "./IntegrationsListItemDisable.vue?vue&type=template&id=31c7ccd6&scoped=true&"
import script from "./IntegrationsListItemDisable.vue?vue&type=script&lang=js&"
export * from "./IntegrationsListItemDisable.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsListItemDisable.vue?vue&type=style&index=0&id=31c7ccd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7ccd6",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsListItemDisable.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsListItemDisable.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog})
